import React, { useEffect, useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Formik } from "formik";
import * as Yup from "yup";
import { DistrictService } from "../../../services/district-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { OrderService } from "../../../services/order-service";
import { useParams } from "react-router-dom/cjs/react-router-dom";

export const Personaldetails = (props) => {
  const format2 = "YYYY-MM-DD";
  const history = useHistory();
  const { orderID } = useParams();
  const [submitloading, setSubmitLoading] = useState(true);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      const finalRe = await OrderService.orderAddressUpdate(props.id, values.name, values.phone1, values.phone2, values.address, values.district, values.city);
      setSubmitLoading(true);
      notify("Delivery details successfully updated");
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  useEffect(() => {
    districtSearch();
  }, []);

  const [districts, setDistricts] = useState([]);

  const districtSearch = async () => {
    try {
      const result = await DistrictService.districtsDetails();
      setDistricts(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  return (
    <div className="col-xl-12 col-md-12">
      <div className="ms-panel ms-panel-fh">
        <div className="ms-panel-body">
          <h2 className="section-title">Basic Customer Information</h2>
          <table className="table ms-profile-information">
            <tbody>
              <tr>
                <th scope="row">Name </th>
                <td>{props.name}</td>
              </tr>
              {/* <tr>
                <th scope="row">Birthday </th>
                <td>{props.birthday}</td>
              </tr>
              <tr>
                <th scope="row">Email</th>
                <td>{props.email}</td>
              </tr> */}
              <tr>
                <th scope="row">Phone 1</th>
                <td>{props.phone}</td>
              </tr>
              <tr>
                <th scope="row">Phone 2</th>
                <td>{props.whatsapp_number}</td>
              </tr>
              
              {/* <tr>
                <th scope="row">Created At</th>
                <td>{moment(props.created_at).format(format2)}</td>
              </tr>
              <tr>
                <th scope="row">Updated At</th>
                <td>{moment(props.updated_at).format(format2)} </td>
              </tr> */}
            </tbody>
          </table>
          <div className="form-row" style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    onClick={() => {
                      history.push(`/customer-edit/${props.userId}`);
                    }}
                  >
                    Edit
                  </button>
          </div>
          <h2 className="section-title mt-5">Delivery Information</h2>
          <div className="ms-panel-body">
          <Formik
            enableReinitialize={true}
            initialValues={{
              name: props.delivery_name,
              phone1: props.delivery_phone1,
              phone2: props.delivery_phone2,
              address: props.delivery_address,
              district: props.delivery_district,
              city: props.delivery_city,
            }}
            validationSchema={Yup.object().shape({
              address: Yup.string().required("Required"),
              district: Yup.string().required("Required"),
              city: Yup.string().required("Required"),
            })}
            onSubmit={onSubmitForm}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              submitForm,
              isValid,
              setFieldValue,
            }) => (
              <>
              <div className="form-row">
                <label htmlFor="validationCustom08">Name</label>
                  <div className="input-group">
                    <input
                      name="name"
                      className="form-control"
                      id="nameId"
                      required
                      onChange={(e) => {
                        setFieldValue("name", e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.name}
                    />
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.name && errors.name}
                  </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="validationCustom08">Phone 1</label>
                  <div className="input-group">
                    <input
                      name="phone1"
                      className="form-control"
                      id="phone1Id"
                      required
                      onChange={(e) => {
                        setFieldValue("phone1", e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.phone1}
                    />
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.phone1 && errors.phone1}
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="validationCustom08">phone 2</label>
                  <div className="input-group">
                    <input
                      name="phone2"
                      className="form-control"
                      id="phone2Id"
                      required
                      onChange={(e) => {
                        setFieldValue("phone2", e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.phone2}
                    />
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.phone2 && errors.phone2}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <label htmlFor="validationCustom08">Address</label>
                  <div className="input-group">
                    <input
                      name="address"
                      className="form-control"
                      id="addressId"
                      required
                      onChange={(e) => {
                        setFieldValue("address", e.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.address}
                    />
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.address && errors.address}
                  </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="validationCustom15">District</label>
                  <div className="input-group">
                    <select
                      name="district"
                      className="form-control"
                      id="district"
                      required
                      value={values.district}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select District</option>
                      {districts?.map((district) =>{
                        return (
                          <option key={district.id} value={district.id}>{district.name_en}</option>
                          
                        )
                      })}
                    </select>
                  </div>
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {touched.district && errors.district}
                  </div>
                </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="validationCustom15">City</label>
                    <div className="input-group">
                      <input
                        name="city"
                        className="form-control"
                        id="cityId"
                        required
                        onChange={(e) => {
                          setFieldValue("city", e.target.value);
                        }}
                        onBlur={handleBlur}
                        value={values.city}
                      />
                      </div>
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {touched.city && errors.city}
                      </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                </div>
                <div
                  className="form-row"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    disabled={props.status == 'CANCELED' || props.status == 'COMPLETED' || props.status == 'DELIVERING'}
                    onClick={submitForm}
                  >
                    Update
                  </button>
              </div>
              </>
            )}
          </Formik>
        </div>
          {/* <table className="table ms-profile-information">
            <tbody>
              <tr>
                <th scope="row">Address</th>
                <td>{props.delivery_address}</td>
              </tr>
              <tr>
                <th scope="row">District</th>
                <td>{props.delivery_district}</td>
              </tr>
              <tr>
                <th scope="row">City</th>
                <td>{props.delivery_city}</td>
              </tr>
            </tbody>
          </table> */}
          
        </div>
      </div>
    </div>
  );
};

export default Personaldetails;
